<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" @visibleChange="addCount">
    <div :class="$style.dropdown">
      <a-badge :count="count">
        <a-avatar shape="square" icon="user" size="large" :class="$style.avatar" />
      </a-badge>
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <strong>{{ $t('topBar.profileMenu.hello') }}, Username</strong>
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.billingPlan') }}:</strong>
          Profissional
        </div>
        <div>
          <strong>{{ $t('topBar.profileMenu.role') }}:</strong>
          Administrador
        </div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.email') }}:</strong> admin@mediatec.org
        </div>
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.phone') }}:</strong> -
        </div>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);">
          <i :class="$style.menuIcon" class="fe fe-user"></i>
          {{ $t('topBar.profileMenu.editProfile') }}
        </a>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript: void(0);" @click="signOut($router)">
          <i :class="$style.menuIcon" class="fe fe-log-out"></i>
          {{ $t('topBar.profileMenu.logout') }}
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapActions } from 'vuex'
import { globalActions as AuthActions } from '@/store/modules/auth/actionTypes'

export default {
  data: function () {
    return {
      count: 7,
    }
  },
  methods: {
    ...mapActions({
      signOut: AuthActions.SIGN_OUT,
    }),
    addCount() {
      this.count++
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
